/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1AuxiliaryFileFilter } from '../models/V1AuxiliaryFileFilter';
import { V1CombinationRule } from '../models/V1CombinationRule';
import { HttpFile } from '../http/http';

/**
* the combination of file filters to be applied during generation
*/
export class V1FileFilters {
    'combinationRule'?: V1CombinationRule;
    /**
    * A list of auxiliary files and the rules used to filter the data.  Each filter allows inclusion or exclusion based on the auxiliary file contents.  Filters will be applied using the CombinationRule specified. Filtering Scenarios:  - 'match_mode: include', 'match_scope: in_auxiliary' → Include all data from the original data that is also in the auxiliary file.  - 'match_mode: exclude', 'match_scope: in_auxiliary' → Exclude all data from the original data that is also in the auxiliary file.  - 'match_mode: include', 'match_scope: not_in_auxiliary' → Include all data from the original data that is NOT in the auxiliary file.  - 'match_mode: exclude', 'match_scope: not_in_auxiliary' → Exclude all data from the original data that is NOT in the auxiliary file.  - 'match_mode: include', 'match_scope: only_in_auxiliary' → Include only data that is in the auxiliary file but NOT in the original data  
    */
    'auxiliaryFileFilters'?: Array<V1AuxiliaryFileFilter>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "combinationRule",
            "baseName": "combination_rule",
            "type": "V1CombinationRule",
            "format": ""
        },
        {
            "name": "auxiliaryFileFilters",
            "baseName": "auxiliary_file_filters",
            "type": "Array<V1AuxiliaryFileFilter>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1FileFilters.attributeTypeMap;
    }

    public constructor() {
    }
}

